import React from "react";
import { View } from "react-native";
import Svg, { Path } from "react-native-svg";

interface StarRatingProps {
  rating?: number;
  totalStars?: number;
  size?: number;
}

const StarRating: React.FC<StarRatingProps> = ({
  rating = 4,
  totalStars = 5,
  size = 38,
}) => {
  return (
    <View style={{ flexDirection: "row", gap: 4 }}>
      {Array.from({ length: totalStars }, (_, index) => {
        const isFilled = index < rating;
        return (
          <Svg
            key={index}
            width={size}
            height={size}
            viewBox="0 0 28 27"
            fill="none"
          >
            <Path
              d="M12.0168 1.38144C12.6155 -0.461181 15.2224 -0.461175 15.8211 1.38145L17.7357 7.27406C18.0034 8.0981 18.7713 8.65602 19.6378 8.65602H25.8337C27.7711 8.65602 28.5766 11.1353 27.0092 12.2741L21.9967 15.9159C21.2957 16.4252 21.0024 17.3279 21.2701 18.152L23.1848 24.0446C23.7835 25.8872 21.6745 27.4194 20.1071 26.2806L15.0945 22.6388C14.3935 22.1295 13.4443 22.1295 12.7434 22.6388L7.73082 26.2806C6.16339 27.4194 4.05443 25.8872 4.65314 24.0446L6.56776 18.152C6.83551 17.3279 6.54219 16.4252 5.84122 15.9159L0.828663 12.2741C-0.738764 11.1352 0.066792 8.65602 2.00424 8.65602H8.2001C9.06655 8.65602 9.83446 8.0981 10.1022 7.27406L12.0168 1.38144Z"
              fill={isFilled ? "#E5E500" : "transparent"}
              stroke="#D4D4D4"
              strokeWidth="1"
            />
          </Svg>
        );
      })}
    </View>
  );
};

export default StarRating;
